import { Guardian } from '@xaamin/guardian';

Guardian.define('perfil.listar', (user) => {
  return user.can('perfil.listar');
});

Guardian.define('perfil.editar', (user) => {
  return user.can('perfil.editar');
});

Guardian.define('perfil.cambiar.contraseña', (user) => {
  return user.can('perfil.cambiar.contraseña');
});

Guardian.define('cuenta.activar', (user) => {
  return user.can('cuenta.activar');
});

Guardian.define('cuenta.informacion.fiscal', (user) => {
  return user.can('cuenta.informacion.fiscal');
});

Guardian.define('api-keys.listar', (user) => {
  return user.can('api-keys.listar');
});

Guardian.define('api-keys.renovar.produccion', (user) => {
  return user.can('api-keys.renovar.produccion');
});

Guardian.define('api-keys.renovar.sandbox', (user) => {
  return user.can('api-keys.renovar.sandbox');
});

Guardian.define('empresas.listar', (user) => {
  return user.can('empresas.listar');
});

Guardian.define('empresas.info', (user) => {
  return user.can('empresas.info');
});

Guardian.define('empresas.crear', (user) => {
  return user.can('empresas.crear');
});

Guardian.define('empresas.editar', (user) => {
  return user.can('empresas.editar');
});

Guardian.define('empresas.asignar.hits', (user) => {
  return user.can('empresas.asignar.hits');
});

Guardian.define('hits.asignar', (user) => {
  return user.can('hits.asignar');
});

Guardian.define('cuenta.administrar.tarjeta', (user) => {
  return user.can('cuenta.administrar.tarjeta');
});